import { api } from "@/api";
import { AddBettingSelectionMappingParams, BettingSelectionMappingDto } from "@/types/ApiResponses/BettingSelection";

export const addBettingSelectionMapping = async (
  params: AddBettingSelectionMappingParams
): Promise<BettingSelectionMappingDto> => {
  const { selectionId, ...body } = params;
  const res = await api.client.post(`/betting-selections-new/${selectionId}/mappings`, body);
  return res.data;
};
